import { ActionType } from "../../interfaces/storeFactory"


export enum AvailableActions {
    SET_GEO_LOCATIONS = 'SET_GEO_LOCATIONS',
    OPEN_LOCATION_SEARCH_POPUP = 'OPEN_LOCATION_SEARCH_POPUP',
    CLOSE_LOCATION_SEARCH_POPUP = 'CLOSE_LOCATION_SEARCH_POPUP',
    SET_SEARCH_QUERY_STRING = 'SET_SEARCH_QUERY_STRING',
    START_LOCATION_SEARCH_LOADING = 'START_LOCATION_SEARCH_LOADING',
    END_LOCATION_SEARCH_LOADING = 'END_LOCATION_SEARCH_LOADING',
    SET_LOCATION_SEARCH_RESULTS = 'SET_LOCATION_SEARCH_RESULTS',
    ADD_LOCATION_SEARCH_RESULTS = 'ADD_LOCATION_SEARCH_RESULTS',
    SET_LOCATION_SEARCH_API_CALL_HAS_ERRORED = 'SET_LOCATION_SEARCH_API_CALL_HAS_ERRORED',
    SET_DATA_QUERY = 'SET_DATA_QUERY',
}

export interface IDataQueryState {
    userLocation: string,
    isLocationSearchPopoverOpen: boolean,
    queryString: string,
    isLoading: boolean,
    results: any,
    hasErrored: boolean,
    dataQuery: object,
}

export default {
    setGeoLocations: (userLocation: string): ActionType<Partial<IDataQueryState>> =>(
        {
            type: AvailableActions.SET_GEO_LOCATIONS,
            payload: {userLocation,}
        }
    ),
    setOpenLocationSearchPopUp: (): ActionType<Partial<IDataQueryState>> => (
        {
            type: AvailableActions.OPEN_LOCATION_SEARCH_POPUP,
            payload: {isLocationSearchPopoverOpen: true}
        }
    ),
    setCloseLocationSearchPopUp: (): ActionType<Partial<IDataQueryState>> => (
        {
            type: AvailableActions.CLOSE_LOCATION_SEARCH_POPUP,
            payload: {isLocationSearchPopoverOpen: false}
        }
    ),
    setSearchQueryString: (queryString: string): ActionType<Partial<IDataQueryState>> => (
        {
            type: AvailableActions.SET_SEARCH_QUERY_STRING,
            payload: {queryString,},
        }
    ),
    startLocationSearchLoading: (): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.START_LOCATION_SEARCH_LOADING,
        payload: {isLoading: true},
    }),
    endLocationSearchLoading: (): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.START_LOCATION_SEARCH_LOADING,
        payload: {isLoading: false}
    }),
    setLocationSearchResults: (results: any): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.SET_LOCATION_SEARCH_RESULTS,
        payload: {results}
    }),
    addLocationSearchResults: (results: any): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.ADD_LOCATION_SEARCH_RESULTS,
        payload: {results}
    }),
    setLocationSearchApiCallHasErrored: (): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.SET_LOCATION_SEARCH_API_CALL_HAS_ERRORED,
        payload: {hasErrored: true,},
    }),
    setDataQuery: (dataQuery: object): ActionType<Partial<IDataQueryState>> => ({
        type: AvailableActions.SET_DATA_QUERY,
        payload:{...dataQuery}
    })
}

